export default "__VITE_ASSET__CNzxlFmv__"